<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ორგანიზაციის დამატება"
            data-toggle="modal"
            data-target="#addEditModal"
            data-backdrop="static"
            data-keyboard="false"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <!--დამატება/რედაქტირება-->
    <div
      class="modal fade bd-example-modal-lg"
      id="addEditModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის თვისებების დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameGeAdd"
                      class="form-control"
                      placeholder="სახელი ქართულად"
                      autofocus="autofocus"
                      v-model="cardLoyalty.nameGe"
                      v-on:input="$v.cardLoyalty.$touch"
                      v-bind:class="{
                        'error-border': $v.cardLoyalty.nameGe.$error,
                        valid:
                          $v.cardLoyalty.nameGe.$dirty &&
                          !$v.cardLoyalty.nameGe.$invalid,
                      }"
                    />
                    <label for="nameGeAdd">სახელი ქართულად</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameEnAdd"
                      class="form-control"
                      placeholder="English Name"
                      autofocus="autofocus"
                      v-model="cardLoyalty.nameEn"
                      v-on:input="$v.cardLoyalty.$touch"
                      v-bind:class="{
                        'error-border': $v.cardLoyalty.nameEn.$error,
                        valid:
                          $v.cardLoyalty.nameEn.$dirty &&
                          !$v.cardLoyalty.nameEn.$invalid,
                      }"
                    />
                    <label for="nameEnAdd">English Name</label>
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameRuAdd"
                      class="form-control"
                      placeholder="имя на русском"
                      autofocus="autofocus"
                      v-model="cardLoyalty.nameRu"
                      v-on:input="$v.cardLoyalty.$touch"
                      v-bind:class="{
                        'error-border': $v.cardLoyalty.nameRu.$error,
                        valid:
                          $v.cardLoyalty.nameRu.$dirty &&
                          !$v.cardLoyalty.nameRu.$invalid,
                      }"
                    />
                    <label for="nameRuAdd">имя на русском</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="identificationCodeAdd"
                      class="form-control"
                      placeholder="საიდენტიფიკაციო კოდი"
                      autofocus="autofocus"
                      v-model="cardLoyalty.identificationCode"
                      v-on:input="$v.cardLoyalty.$touch"
                      v-bind:class="{
                        'error-border':
                          $v.cardLoyalty.identificationCode.$error,
                        valid:
                          $v.cardLoyalty.identificationCode.$dirty &&
                          !$v.cardLoyalty.identificationCode.$invalid,
                      }"
                    />
                    <label for="identificationCodeAdd"
                      >საიდენტიფიკაციო კოდი</label
                    >
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="number"
                      id="rateAdd"
                      class="form-control"
                      placeholder="ქულების კონვერტაციის კოეფიციენტი"
                      autofocus="autofocus"
                      v-model="cardLoyalty.rate"
                      v-on:input="$v.cardLoyalty.$touch"
                      v-bind:class="{
                        'error-border': $v.cardLoyalty.rate.$error,
                        valid:
                          $v.cardLoyalty.rate.$dirty &&
                          !$v.cardLoyalty.rate.$invalid,
                      }"
                    />
                    <label for="rateAdd"
                      >ქულების კონვერტაციის კოეფიციენტი</label
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              v-if="!isEdit"
              type="button"
              class="btn btn-success"
              :disabled="!$v.cardLoyalty.$dirty || $v.cardLoyalty.$error"
              @click="$v.cardLoyalty.$touch(), addCardLoyalty()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isEdit"
              type="button"
              class="btn btn-success"
              :disabled="!$v.cardLoyalty.$dirty || $v.cardLoyalty.$error"
              @click="$v.cardLoyalty.$touch(), editCardLoyalty()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">დასახელება</th>
            <th class="numeric">საიდენტიფიკაციო კოდი</th>
            <th class="numeric">ქულების კონვერტაციის კოეფიციენტი</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="value in cardLoyaltyOrganizationsArray"
            :key="value.id"
          >
            <td data-title="დასახელება" class="numeric">
              {{ value.name }}
            </td>
            <td data-title="საიდენტიფიკაციო კოდი" class="numeric">
              {{ value.identificationCode }}
            </td>
            <td data-title="ქულების კონვერტაციის კოეფიციენტი" class="numeric">
              {{ value.rate }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#addEditModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="editFillInputs(value), modalPrepareEdit()"
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#deleteModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="getDeleteId(value.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="deleteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ლოიალობის ბარათის ორგანიზაციის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteCardLoyalty()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";

export default {
  name: "cardLoyalty",
  data() {
    return {
      cardLoyalty: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        identificationCode: "",
        rate: null,
      },
      isEdit: false,
      cardLoyaltyOrganizationsArray: [],
    };
  },
  validations: {
    cardLoyalty: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
      identificationCode: {
        required,
      },
      rate: {
        required,
      },
    },
  },
  async created() {
    let result = await this.$http.getCardLoyaltyOrganizations();
    this.cardLoyaltyOrganizationsArray = result.data.res;
  },
  methods: {
    async addCardLoyalty() {
      try {
        let result = await this.$http.addCardLoyaltyOrganization(
          this.cardLoyalty
        );

        if (result.data.res === "200") {
          bus.$emit("success", "წარმატებით დაემატა");

          let orgList = await this.$http.getCardLoyaltyOrganizations();
          this.cardLoyaltyOrganizationsArray = orgList.data.res;
        } else {
          bus.$emit("warning", "დამატების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editCardLoyalty() {
      try {
        let result = await this.$http.editCardLoyaltyOrganization(
          this.cardLoyalty
        );

        if (result.data.res === "200") {
          bus.$emit("success", "წარმატებით დარედაქტირდა");
          let orgList = await this.$http.getCardLoyaltyOrganizations();
          this.cardLoyaltyOrganizationsArray = orgList.data.res;
        } else {
          bus.$emit("warning", "რედაქტირების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteCardLoyalty() {
      try {
        let result = await this.$http.deleteCardLoyaltyOrganization(
          this.cardLoyalty.id
        );

        if (result.data.res === "200") {
          bus.$emit("success", "წარმატებით წაიშალა");

          let orgList = await this.$http.getCardLoyaltyOrganizations();
          this.cardLoyaltyOrganizationsArray = orgList.data.res;
        } else {
          bus.$emit("warning", "წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      this.modalPrepare();
      let result = await this.$http.getCardLoyaltyOrganization(row.id);
      this.cardLoyalty = result.data.res;
    },
    getDeleteId(id) {
      this.cardLoyalty.id = id;
    },
    modalPrepareEdit() {
      this.isEdit = true;
    },
    modalPrepare() {
      this.isEdit = false;
    },
    clearData() {
      this.cardLoyalty.id = null;
      this.cardLoyalty.nameGe = "";
      this.cardLoyalty.nameEn = "";
      this.cardLoyalty.nameRu = "";
      this.cardLoyalty.identificationCode = "";
      this.cardLoyalty.rate = null;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/CardLoyalty.vue